import { Checkbox, FormControlLabel } from '@mui/material';
import { RequestVM } from 'civil-status/view-models/step-form';
import { useFormikContext } from 'formik';
import { memo } from 'react';

interface BirthdayDocumentFormProps {
  request?: RequestVM;
  disabled?: boolean;
}

const CheckboxRequestComponent = ({
  request,
  disabled,
}: BirthdayDocumentFormProps): React.ReactElement => {
  const formContext = useFormikContext<Record<string, string | boolean>>();

  const name = request?.name || '';

  return (
    <FormControlLabel
      control={
        <Checkbox
          id={request?.request}
          checked={Boolean(formContext.values[name])}
          onChange={() =>
            formContext.setValues({
              ...(formContext.values || {}),
              [name]: !Boolean(formContext.values[name]),
            })
          }
          inputProps={{ 'aria-label': request?.request || '' }}
          disabled={disabled}
        />
      }
      label={request?.request || ''}
    />
  );
};

CheckboxRequestComponent.displayName = 'Checkbox Request component';

const CheckboxRequest = memo(CheckboxRequestComponent);

export default CheckboxRequest;
